import React, { useEffect, useState } from 'react'
import Graytextarea from '../../components/Graytextarea'
import { useIndexedDB } from '../../context/IndexedContext'
import HospitalRecords from './Noteedit/hospital-records'

import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow, CTooltip } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus, View, Eye, Edit, X } from 'lucide-react'
import HistoryRecords from './Noteedit/history-records'
import InternalNotes from './Noteedit/internal-notes'
import AllergiesRecords from './Noteedit/allergies-records'
import VitalRecords from './Noteedit/vitals-records'
import ImagingRecords from './Noteedit/imaging-records'
import LabRecords from './Noteedit/labs-records'
import MedsRecords from './Noteedit/meds-records'
import IncidentGlobalRecords from './Noteedit/incidents-global'
import HpiRecords from './Noteedit/hpi-records'
import ReviewSystem from './Noteedit/reviewofsystem-records'
import TreatmentShell from './Noteedit/treatmentshell-records'
import PhysicalExaminationRecords from './Noteedit/physicalexamination-records'
import PoacGlobal from './Noteedit/poac-global'
import PoacGlobalRecords from './Noteedit/poac-records'
import toast from 'react-hot-toast'
import PatientDetailsRecords from './Noteedit/patientdetails-records'
import PhysicalExaminationRecordsFreetype from './Noteedit/physicalexamination-freetype'
import LabsFreeType from './Noteedit/labs-freetype'
import MedsRecordsFreetype from './Noteedit/meds-records-freetype'
import ImagingRecordsFreetype from './Noteedit/imaging-recors-freetype'
import AllergiesFreeType from './Noteedit/allergies-freetype'
import VitalRecordsFreetype from './Noteedit/vitals-recordfree'
import HospitalRecordsFreeType from './Noteedit/hospital-recordsfreetype'
import HistoryRecordsFreeType from './Noteedit/hsitories-freetype'
import PatientDetailsRecordsFreetype from './Noteedit/patientdetails-freetype'

const ProviderPreSignedChartNoteEdit = ({ setEditNoteIndex, editNoteIndex, visibleEditNote, setVisibleEditNote, editNoteId, patientData, setEditNoteDataId, patientID, setShowSignedModel, patientDBData }) => {
  const { checkIfMastersExist, getPreSignedAppointment, getCallCenterQuestions, saveCallCenterQuestions, savePreSignedData, getPreSignedData, getProviderDetails, getAllMasterDiagnosis } = useIndexedDB()

  const [patientDBdata, setPatientDBdata] = useState(null)
  const [tempPatientDBdata, setTempPatientDBdata] = useState(null)
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [isSavingTheData, setIsSavingTheData] = useState(false)
  const [MasterDiagnosisData, setMasterDiagnosisData] = useState([])
  const [diagnosisCodes, setDiagnosisCodes] = useState({})
  const [questionValue, setQuestionsValue] = useState({})
  const [poacValueGlobal, setPoacValueGlobal] = useState('')

  const fetchhDiagnosisMaster = async () => {
    let formattedDataDiagnosis
    // formattedDataDiagnosis = await GetDiagnosisData()
    const getAllMasterDiagnosiss = await getAllMasterDiagnosis()
    let allDiagnosisCodes = {}
    if (getAllMasterDiagnosiss) {
      formattedDataDiagnosis = getAllMasterDiagnosiss?.Data
      for (const diagnosis of formattedDataDiagnosis) {
        allDiagnosisCodes[diagnosis.Name.trim()] = diagnosis.Code
      }
    }
    console.log(allDiagnosisCodes, formattedDataDiagnosis, 'allDiagnosisCodes')
    setDiagnosisCodes(allDiagnosisCodes)
    setMasterDiagnosisData(formattedDataDiagnosis)
  }

  useEffect(() => {
    fetchhDiagnosisMaster()
  }, [])

  const getProvidersMaster = async () => {
    try {
      const getProviderDetailsData = await getProviderDetails()

      const data = await getPreSignedData()
      console.log(' get alll data with type', data)
      const DBData = data[getProviderDetailsData?.ID] || []
      const patientWiseDBdata = DBData[patientID] || {}
      console.log(patientWiseDBdata, 'patientWiseDBdata')
      setPatientDBdata(patientWiseDBdata)
      setTempPatientDBdata(patientWiseDBdata)
      console.log(getProviderDetailsData, patientWiseDBdata, patientID, 'getProviderDetailsData')

      setLoggedUserProvider(getProviderDetailsData || {})
      // let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      // providerData = JSON.parse(providerData.d)?.Data
      // const getUser = JSON.parse(localStorage.getItem('user'))

      // const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      // setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [patientID])

  // const handleUpdatePatient = async () => {
  //   let cachedNotesData = await getPreSignedAppointment()

  //   if (cachedNotesData) {
  //     try {
  //       let parsedNotes = JSON.parse(cachedNotesData)
  //       console.log(parsedNotes, 'parsedNotes')
  //       const newlyPatientUpdates = patientDBdata?.newlyAddedData?.updatedPatientData
  //       if (!newlyPatientUpdates) return

  //       if (Array.isArray(parsedNotes)) {
  //         parsedNotes = parsedNotes.map((item) => {
  //           if (item.PatientID === patientID) {
  //             return {
  //               ...item,
  //               ...newlyPatientUpdates
  //             }
  //           }
  //           return item
  //         })

  //       }

  //       console.log(parsedNotes, 'parsedNotes')
  //       await savePreSignedData(JSON.parse(parsedNotes))
  //     } catch (err) {

  //     }
  //   }
  // }

  const handleSaveCallCenterEdits = async () => {
    let allData = await getCallCenterQuestions()
    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...item,
        JsonData: JSON.parse(item?.JsonData),
        // CreatedAt: item?.CreatedAt,
      }
    })

    const updatedAllQuestionValue = allPatientHpiData.map((item) => {
      if (item?.JsonData?.[patientID]) {
        return {
          ...item,
          JsonData: {
            ...item?.JsonData,
            [patientID]: {
              CCENTER: questionValue,
              globalFreeType: poacValueGlobal,
            },
          },
        }
      }
      return item
    })
    console.log(updatedAllQuestionValue, 'updatedAllQuestionValue')

    const jsonFormat = updatedAllQuestionValue.map((item) => {
      return {
        ...item,
        JsonData: JSON.stringify(item?.JsonData),
      }
    })
    console.log(jsonFormat, 'jsonFormat')

    const dataToPut = {
      IDNumber: '',
      Data: jsonFormat,
    }

    console.log(dataToPut, 'dataToPut')
    await saveCallCenterQuestions(dataToPut)
  }

  const handleSaveNote = async () => {
    setIsSavingTheData(true)

    try {
      const getAllData = await getPreSignedData()

      if (!getAllData || !getAllData[loggedUserProvider?.ID] || !getAllData[loggedUserProvider?.ID][patientID]) {
        return
      }

      const updatedData = {
        ...getAllData,
        [loggedUserProvider?.ID]: {
          ...getAllData[loggedUserProvider?.ID],
          [patientID]: patientDBdata,
        },
      }
      await savePreSignedData(updatedData)

      await handleSaveCallCenterEdits()
      // setVisibleEditNote(false)
      setIsSavingTheData(false)
      toast.success('Patient Data Saved Successfully')
    } catch (error) {
      console.log(error, 'error in hp')
    }
  }

  return (
    <CModal
      backdrop="static"
      fullscreen
      visible={visibleEditNote}
      onClose={() => {
        setVisibleEditNote(false)
      }}
      aria-labelledby="FullscreenExample1"
    >
      <CModalHeader
        closeButton={false}
        style={{
          backgroundColor: '#282828',
          borderBottom: '1px solid gray',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          borderRadius: '10px 10px 0 0',
        }}
      >
        <CModalTitle style={{ color: 'white', width: '100%' }} id="FullscreenExample1">
          Edit Note
        </CModalTitle>
        <X onClick={() => setVisibleEditNote(false)} style={{ color: 'white', cursor: 'pointer' }} />
      </CModalHeader>
      <CModalBody
        className=""
        style={{
          backgroundColor: '#282828',
          color: 'white',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <PatientDetailsRecordsFreetype setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          {/* <PatientDetailsRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <HospitalRecordsFreeType noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          {/* <HospitalRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          {/* <HistoryRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <HistoryRecordsFreeType noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />

          {/* <InternalNotes setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          {/* <AllergiesRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <AllergiesFreeType noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <VitalRecordsFreetype noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          {/* <VitalRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          {/* <ImagingRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <ImagingRecordsFreetype noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <LabsFreeType noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          {/* <LabRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          {/* <MedsRecords setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <MedsRecordsFreetype noteActualId={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <IncidentGlobalRecords noteId={editNoteId} isSavingTheData={isSavingTheData} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <HpiRecords isSavingTheData={isSavingTheData} noteID={editNoteIndex} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <ReviewSystem isSavingTheData={isSavingTheData} noteID={editNoteId} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          {/* <PhysicalExaminationRecords MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={editNoteIndex} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} /> */}
          <PhysicalExaminationRecordsFreetype MasterDiagnosisData={MasterDiagnosisData} isSavingTheData={isSavingTheData} noteID={editNoteIndex} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} />
          <hr />
          <div style={{ minWidth: '23%' }}>ASSESSMENT/PLAN</div>
          <PoacGlobal
            poacValueGlobal={poacValueGlobal}
            setPoacValueGlobal={setPoacValueGlobal}
            MasterDiagnosisData={MasterDiagnosisData}
            isSavingTheData={isSavingTheData}
            noteID={editNoteIndex}
            setPatientDBdata={setPatientDBdata}
            patientDBdata={patientDBdata}
            patientID={patientID}
            loggedUserProvider={loggedUserProvider}
          />
          <hr />
          <TreatmentShell
            questionValue={questionValue}
            setQuestionsValue={setQuestionsValue}
            MasterDiagnosisData={MasterDiagnosisData}
            isSavingTheData={isSavingTheData}
            noteID={editNoteId}
            editNoteIndex={editNoteIndex}
            setPatientDBdata={setPatientDBdata}
            patientDBdata={patientDBdata}
            patientID={patientID}
            loggedUserProvider={loggedUserProvider}
          />
        </div>
      </CModalBody>

      <CModalFooter
        className="p-0 m-0 p-4 d-flex justify-content-end"
        style={{
          borderTop: '0.1px solid white',
          backgroundColor: '#282828',
          color: 'white',
        }}
      >
        <CButton
          variant="outline"
          style={{
            borderColor: '#0066fe',
            color: '#0066fe',
          }}
          onClick={handleSaveNote}
        >
          Save Note
        </CButton>
        <CTooltip content={patientDBData?.newlyAddedData?.patientSuperBill?.length > 0 ? 'Click To Sign Note' : 'Submit SuperBill to Sign Note'} placement="top">
          <span className="d-inline-block">
            <CButton
              variant="outline"
              color="success"
              onClick={() => setShowSignedModel(true)}
              disabled={patientDBData?.newlyAddedData?.patientSuperBill?.length === 'undefined' || patientDBData?.newlyAddedData?.patientSuperBill?.length > 0 ? false : true}
              style={{
                borderColor: patientDBData?.newlyAddedData?.patientSuperBill?.length > 0 ? '' : '#00fb047a',
                color: patientDBData?.newlyAddedData?.patientSuperBill?.length > 0 ? '' : '#00fb047a',
              }}
            >
              {console.log('patientDBData?.newlyAddedData?.patientSuperBill?.length', patientDBData?.newlyAddedData?.patientSuperBill?.length)}
              Sign Note
            </CButton>
          </span>
        </CTooltip>
      </CModalFooter>
    </CModal>
  )
}

export default ProviderPreSignedChartNoteEdit
